<template>
	<transition name="slide-fade">
		<div
			v-if="isRecording"
			class="recording-panel"
			:class="{ 'recording-panel--locked': isLocked }"
		>
			<div class="progress-container">
				<q-linear-progress
					:value="progress"
					color="primary"
					class="progress-bar"
					instant-feedback
				/>
				<span class="recording-time">{{ formattedDuration }}</span>
				<div v-show="isLocked" class="action-buttons">
					<q-btn
						icon="stop"
						round
						color="primary"
						size="sm"
						@click.stop="$emit('stop')"
						class="stop-btn"
					/>
					<q-btn
						icon="close"
						round
						color="primary"
						size="sm"
						@click.stop="$emit('cancel')"
						class="cancel-btn"
					/>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
	name: 'RecordingPanel',
	props: {
		isRecording: {
			type: Boolean,
			default: false
		},
		isLocked: {
			type: Boolean,
			default: false
		},
		progress: {
			type: Number,
			default: 0
		},
		formattedDuration: {
			type: String,
			default: '00:00'
		}
	},
	emits: ['stop', 'cancel']
});
</script>

<style scoped lang="scss">
.recording-panel {
	display: flex;
	align-items: center;
	background: white;
	border-radius: 24px;
	padding: 8px 16px;
	box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
	min-width: 160px;
	transition: all 0.3s;

	&.recording-panel--locked {
		min-width: 220px;
	}
}

.progress-container {
	display: flex;
	align-items: center;
	gap: 10px;
	width: 100%;
}

.progress-bar {
	flex: 1;
	height: 4px;
	border-radius: 2px;
}

.recording-time {
	font-size: 13px;
	font-weight: 500;
	color: #333;
	min-width: 36px;
	text-align: center;
}

.action-buttons {
	display: flex;
	gap: 4px;
	margin-left: 6px;
}

.stop-btn,
.cancel-btn {
	width: 28px;
	height: 28px;
	min-height: 28px;

	:deep(.q-icon) {
		font-size: 16px;
	}
}

@media screen and (min-width: 767px) {
	.recording-panel {
		min-width: 180px;

		&.recording-panel--locked {
			min-width: 240px;
		}
	}
}

@media screen and (max-width: 380px) {
	.recording-panel {
		min-width: 140px;

		&.recording-panel--locked {
			min-width: 200px;
		}
	}
}
</style>
